import React, { useState, useEffect }  from "react";
import MainView from "../../../components/MainView";

import './styles.css';

import partnerServices from '../../../services/admFin/partnerServices';
import companyServices from '../../../services/admFin/companyServices';
import costCenterServices from '../../../services/admFin/costCenterServices';
import billsPlanServices from '../../../services/admFin/billsPlanServices';
import paymentMethodServices from '../../../services/admFin/paymentMethodServices';
import bankAccountServices from '../../../services/admFin/bankAccountServices';
import compare from "../../../functions/compare";

import PartnersCard from "./PartnersCard";
import NavHistory from "../../../components/NavHistory";
import { FaBuilding, FaCreditCard, FaDollarSign, FaPeopleArrows, FaPersonBooth, FaPiggyBank, FaWallet } from "react-icons/fa";
import { FaPeopleCarry } from "react-icons/fa";
import CostCentersCard from "./CostCentersCard";
import BillsPlansCard from "./BillsPlansCard";
import BankAccountsCard from "./BankAccountsCard";
import CompaniesCard from "./CompaniesCard";
import PaymentMethodsCard from "./PaymentMethodsCard";
import collaboratorServices from "../../../services/admFin/collaboratorServices";
import CollaboratorsCard from "./CollaboratorsCard";

export default function RecordsPage(props) {
    const [partners, setPartners] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [costCenters, setCostCenters] = useState([]);
    const [billsPlans, setBillsPlans] = useState([]);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [bankAccounts, setBankAccounts] = useState([]);
    const [collaborators, setCollaborators] = useState([]);

    async function getPartners() {
        try{
            const response = await partnerServices.getPartners();
            setPartners(response.data.sort((a, b) => compare(a.nome, b.nome)));
        } 
        catch(err) {
            alert("Erro ao ler parceiros, tente novamente!");
        }
    }

    async function getCompanies() {
        try{
            const response = await companyServices.getCompanies();
            setCompanies(response.data.sort((a, b) => compare(a.nome, b.nome)));
        } 
        catch(err) {
            alert("Erro ao ler empresas, tente novamente!");
        }
    }

    async function getCostCenters() {
        try{
            const response = await costCenterServices.getCostCenters();
            setCostCenters(response.data.sort((a, b) => compare(a.nome, b.nome)));
        } 
        catch(err) {
            alert("Erro ao ler centros de custo, tente novamente!");
        }
    }

    async function getBillsPlans() {
        try{
            const response = await billsPlanServices.getBillsPlans();
            setBillsPlans(response.data.sort((a, b) => compare(a.nome, b.nome)));
        } 
        catch(err) {
            alert("Erro ao ler planos de conta, tente novamente!");
        }
    }

    async function getBankAccounts() {
        try{
            const response = await bankAccountServices.getBankAccounts();
            setBankAccounts(response.data);
        } 
        catch(err) {
            alert("Erro ao ler contas bancárias, tente novamente!");
        }
    }

    async function getPaymentMethods() {
        try{
            const response = await paymentMethodServices.getPaymentMethods();
            setPaymentMethods(response.data.sort((a, b) => compare(a.nome, b.nome)));
        } 
        catch(err) {
            alert("Erro ao ler métodos de pagamento, tente novamente!");
        }
    }

    async function getCollaborators() {
        try{
            const response = await collaboratorServices.getCollaborators();
            setCollaborators(response.data.sort((a, b) => compare(a.nome, b.nome)));
        } 
        catch(err) {
            alert("Erro ao ler colaboradores, tente novamente!");
        }
    }

    async function deleteElement(id, deleteFunction,setElements) {
        // eslint-disable-next-line no-restricted-globals
        if(confirm("Deseja deletar este cadastro?")) {
            try {
                await deleteFunction(id);

                setElements(oldArray => {
                    const temp = [...oldArray];
                    return temp.filter(obj => obj.id !== id);
                })
            } catch(err) {
                alert("Erro ao deletar cadastro");
            }
        }
    }

    useEffect(() => {
        getPartners();
        getCompanies();
        getCostCenters();
        getBillsPlans();
        getBankAccounts();
        getPaymentMethods();
        getCollaborators();
    }, []);

    return (
        <MainView currentPage = 'records' admFinMenu>
            <div className="records-page-container">
                <NavHistory navPages={['Cadastros']} />

                <PartnersCard
                    tittle={<><FaPeopleCarry/> Fornecedores</>}
                    partners = {partners.filter(partner => partner.parceria === 1)}
                    setPartners={setPartners}
                    parceria={1}
                    deleteElement={deleteElement}
                    icon={<FaPeopleCarry/>}
                />

                <PartnersCard
                    tittle={<><FaPeopleArrows/> Clientes</>}
                    partners = {partners.filter(partner => partner.parceria === 0)}
                    setPartners={setPartners}
                    parceria={0}
                    deleteElement={deleteElement}
                    icon={<FaPeopleArrows/>}
                />

                <CompaniesCard
                    tittle={<><FaBuilding/> Empresas</>}
                    companies={companies}
                    bankAccounts={bankAccounts}
                    setCompanies={setCompanies}
                    deleteElement={deleteElement}
                />

                <CollaboratorsCard
                    tittle={<><FaPersonBooth/> Colaboradores</>}
                    collaborators={collaborators}
                    companies={companies}
                    setCollaborators={setCollaborators}
                    deleteElement={deleteElement}
                />

                <CostCentersCard
                    tittle = {<><FaDollarSign/> Centros de Custo</>}
                    costCenters={costCenters}
                    setCostCenters={setCostCenters}
                    deleteElement={deleteElement}

                />

                <BillsPlansCard
                    tittle={<><FaWallet/> Planos de Contas</>}
                    billsPlans={billsPlans}
                    setBillsPlans={setBillsPlans}
                    deleteElement={deleteElement}

                />

                {/* <BankAccountsCard
                    tittle={<><FaPiggyBank/> Contas Bancárias</>}
                    bankAccounts={bankAccounts}
                    setBankAccounts={setBankAccounts}
                    deleteElement={deleteElement}

                /> */}

                <PaymentMethodsCard
                    tittle={<><FaCreditCard/> Formas de Pagamento</>}
                    paymentMethods={paymentMethods}
                    setPaymentMethods={setPaymentMethods}
                    deleteElement={deleteElement}

                />
            </div>
        </MainView>
    )
}